<template>
  <div>
    <b-row>
      <b-col sm="8">
        <b-form-group label="Descrição" label-for="descricao">
          <b-form-input
            v-model="form.descricao"
            autocomplete="off"
            maxLength="100"
          />
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          id="data_manutencao"
          label-for="data_manutencao"
          label="Data Manutenção"
        >
          <b-form-datepicker
            v-model="form.data_manutencao"
            :state="validateState('data_manutencao')"
            locale="pt-br"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          >
          </b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col sm="8">
        <b-form-group label="Cliente" label-for="nome">
          <CadastroRapidoSelect
            ref="buscarCliente"
            :state="validateState('cliente')"
            entity-label="cliente"
            :min-create-length="3"
            :creating="criandoCliente"
            :value="form.cliente"
            @input="setCliente"
            @create="criarClienteInline"
            :options="clientes"
            @search="onSearchCliente"
            :clearSearchOnSelect="true"
          >
            <template slot="no-options"> Informe o nome do cliente </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>{{ option.codigo }} - {{ option.nome }}</div>
                <span class="text-muted"
                  >CPF: {{ formatCpfCnpj(option.cnpj_cpf) }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </CadastroRapidoSelect>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Técnico" label-for="tecnico">
          <CadastroRapidoSelect
            ref="buscarTecnico"
            :state="validateState('tecnico')"
            entity-label="técnico"
            :min-create-length="3"
            :creating="criandoTecnico"
            :value="form.tecnico"
            @input="setTecnico"
            @create="criarTecnicoInline"
            :class="{ hasErrors: tecnicoError, inputFilled: tecnicoFilled }"
            :options="tecnicos"
            @open="onSearchTecnico"
            @search="onSearchTecnico"
            :clearSearchOnSelect="true"
          >
            <template slot="no-options"> Informe o nome do tecnico </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  {{ option.nome }}
                </div>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </CadastroRapidoSelect>
        </b-form-group>
      </b-col>
      <b-col sm="10">
        <b-form-group label="Objeto" label-for="objeto">
          <CadastroRapidoSelect
            ref="buscarObjeto"
            label="descricao"
            entity-label="objeto"
            :min-create-length="3"
            :creating="criandoObjeto"
            :value="form.objeto"
            @input="setObjeto"
            @create="criarObjetoInline"
            :options="objetos"
            @open="onSearchObjetos"
            @search="onSearchObjetos"
            :clearSearchOnSelect="true"
          >
            <template slot="no-options"> Informe o nome do objeto </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  {{ option.descricao }}
                </div>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.descricao }}
              </div>
            </template>
          </CadastroRapidoSelect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-modal
      id="confirmObjectModal"
      centered
      title="Vários Objetos para um mesmo cliente"
    >
      <b-row>
        <b-col>
          <p>
            Este cliente possui vários objetos cadastrados. Por favor, selecione
            o objeto desejado abaixo.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <VueSelect
              ref="buscarObjeto"
              :filterable="false"
              :searchable="false"
              v-model="objetoSelected"
              :options="objetosFetched"
              :clearSearchOnSelect="true"
            >
              <template slot="no-options"> Informe o nome do objeto </template>
              <template slot="option" slot-scope="option">
                <div class="d-flex justify-content-between">
                  <div>
                    {{ option.descricao }}
                  </div>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.descricao }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="objetoSelected?.identificadores?.length > 0">
        <b-col
          v-for="identificador in ordenarIdentificadores(objetoSelected.identificadores)"
          :key="identificador.id_identificador"
          sm="4"
        >
          <b-form-group
            :label="identificador.descricao"
            :label-for="identificador.descricao"
          >
            <b-form-input :value="identificador.value" disabled />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          @click="
            () => {
              cancel();
              openModal = false;
            }
          "
        >
          Cancelar
        </b-button>
        <b-button variant="primary" ref="confirmObject" @click="confirmObject">
          Confirmar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../../Application/mixins/FormatMixin";
import GeraisData, { NFeDataRequired } from "../GeraisData";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../../Pdv/mixins/PagamentosMixin";
import { store } from "../../storeSimplificada";
import InstallmentsMixin from "../../../Application/mixins/InstallmentsMixin";
import EmitenteMixin from "../../../Application/mixins/EmitenteMixin";
import CadastroRapidoSelect from "@/components/CadastroRapidoSelect.vue";
import CadastroRapidoMixin from "@/modules/Application/mixins/CadastroRapidoMixin";

export default {
  name: "app-os-form-geraisTab",
  components: {
    VueSelect,
    CadastroRapidoSelect,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {},
      clientes: [],
      enderecos: [],
      tecnicos: [],
      objetos: [],
      objetosFetched: [],
      objetoSelected: null,
      clienteError: false,
      clienteFilled: false,
      enderecoError: false,
      tecnicoError: false,
      enderecoFilled: false,
      tecnicoFilled: false,
      store,
      listaPreco: null,
      criandoCliente: false,
      criandoTecnico: false,
      criandoObjeto: false,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
    EmitenteMixin,
    CadastroRapidoMixin,
  ],
  validations: {
    form: NFeDataRequired,
  },
  methods: {
    ordenarIdentificadores(identificadores) {
      if (!Array.isArray(identificadores)) return [];

      return [...identificadores].sort(
        (a, b) =>
          Number(a?.id_identificador || 0) -
          Number(b?.id_identificador || 0)
      );
    },
    ...mapActions(["setLoading"]),
    formatKeyDevolution(e) {
      return String(e).substring(0, 44);
    },
    confirmObject() {
      this.setObjeto(this.objetoSelected);
      this.store.formObjeto = {
        ...this.objetoSelected,
        fromSetClient: true,
      };
      this.objetoSelected = null;
      this.$bvModal.hide("confirmObjectModal");
    },
    async setCliente(cliente) {
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.$set(this.form, "cliente", {});
        this.clienteFilled = false;
        return;
      }

      this.$set(this.form, "cliente", cliente || null);
      this.clienteFilled = Boolean(cliente?.id_pessoa);
      this.setObjeto(null);
      this.objetosFetched = [];

      const { id_pessoa } = cliente || {};
      if (!id_pessoa) return;

      const response = await this.$http.post("/objeto/get-objeto", {
        pessoa: id_pessoa,
      });
      this.objetosFetched = response.data;

      if (this.objetosFetched.length > 0 && this.objetosFetched.length === 1) {
        this.setObjeto(this.objetosFetched[0]);
        this.store.formObjeto = {
          ...this.objetosFetched[0],
          fromSetClient: true,
        };
      } else if (this.objetosFetched.length > 1) {
        this.$bvModal.show("confirmObjectModal");
      }
    },
    setTecnico(tecnico) {
      this.$set(this.form, "tecnico", tecnico || null);
      this.tecnicoFilled = Boolean(tecnico?.id_tecnico);
    },
    setObjeto(objeto) {
      this.$set(this.form, "objeto", objeto || null);
    },
    async getDataInit() {
      this.form = new GeraisData({});
      this.form.data_manutencao = this.thisDate();

      if (Object.keys(this.$route.params).length !== 0) {
        this.handleLoading(true);
        const { cliente, tecnico, data_manutencao, descricao, objeto } =
          this.$route.params.osData;
        this.form.cliente = cliente;

        this.form.tecnico = tecnico;
        this.form.data_manutencao = data_manutencao;
        this.form.objeto = objeto;
        this.form.descricao = descricao;
        this.handleLoading(false);
      } else {
        console.log("");
      }
    },
    handleLoading(value) {
      this.setLoading(value);
    },

    onSearchCliente(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = [];
      await vm.$nextTick();
      const data = await vm.getClientes(search);
      vm.clientes = _.cloneDeep(data);
      loading(false);
    }, 500),

    onSearchTecnico(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchTecnico(busca.loading, busca.termo, this);
    },
    searchTecnico: _.debounce(async (loading, search, vm) => {
      vm.tecnicos = [];
      await vm.$nextTick();
      const data = await vm.getTecnicos(search);
      vm.tecnicos = _.cloneDeep(data);
      loading(false);
    }, 500),

    async criarClienteInline(nome) {
      if (this.criandoCliente) return;

      this.criandoCliente = true;
      try {
        const cliente = await this.criarClienteCadastroRapido(nome);
        this.clientes = [
          cliente,
          ...this.clientes.filter(
            (item) => item.id_pessoa !== cliente.id_pessoa
          ),
        ];
        await this.setCliente(cliente);
        this.$toast.success("Cliente criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o cliente."
          )
        );
      } finally {
        this.criandoCliente = false;
      }
    },
    async criarTecnicoInline(nome) {
      if (this.criandoTecnico) return;

      this.criandoTecnico = true;
      try {
        const tecnico = await this.criarTecnicoCadastroRapido(nome);
        this.tecnicos = [
          tecnico,
          ...this.tecnicos.filter(
            (item) => item.id_tecnico !== tecnico.id_tecnico
          ),
        ];
        this.setTecnico(tecnico);
        this.$toast.success("Técnico criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o técnico."
          )
        );
      } finally {
        this.criandoTecnico = false;
      }
    },
    async criarObjetoInline(descricao) {
      if (this.criandoObjeto) return;

      this.criandoObjeto = true;
      try {
        const objeto = await this.criarObjetoCadastroRapido(
          descricao,
          this.form.cliente?.id_pessoa ?? null
        );
        this.objetos = [
          objeto,
          ...this.objetos.filter((item) => item.id_objeto !== objeto.id_objeto),
        ];
        this.setObjeto(objeto);
        this.$toast.success("Objeto criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o objeto."
          )
        );
      } finally {
        this.criandoObjeto = false;
      }
    },

    cleanErrors() {
      this.naturezaError = false;
      this.finalidadeError = false;
    },
    validateState(name) {
      // const { $dirty, $error } = this.$v.form[name];
      // return $dirty ? !$error : null;
    },
    onSearchObjetos(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchObjeto(busca.loading, busca.termo, this);
    },
    searchObjeto: _.debounce(async (loading, search, vm) => {
      vm.objetos = [];
      await vm.$nextTick();
      const data = await vm.getObjeto(search);
      vm.objetos = _.cloneDeep(data);
      loading(false);
    }, 500),
  },
  mounted() {
    this.getDataInit();
  },
  watch: {
    form: {
      handler(newValue) {
        this.store.formGerais = newValue;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
  },
};
</script>

<style>
.hasErrors .vs__dropdown-toggle {
  border: 2px solid red;
  /* color: #394066; */
}

.hasErrors .vs__clear,
.hasErrors .vs__open-indicator {
  fill: red;
}

.inputFilled .vs__dropdown-toggle {
  border: 2px solid #1bc5bd;
  /* color: #394066; */
}

.inputFilled .vs__clear,
.inputFilled .vs__open-indicator {
  fill: #1bc5bd;
}
</style>
